module.exports = __webpack_public_path__ + "img/361.330a651a.png";